<template>
  <div id="dialog-insu-company-picker">
    <span class="cls" @click="quit()"></span>
    
    <div class="paper">
      <div class="header">
        <h2>게시물 선택</h2>
        <button @click="quit()">X</button>
      </div>
      <div class="chooser">
        <input type="text" placeholder="Search..." v-model="searchText" @input="searchInput"/>
      </div>
      <div class="content">
        <ul>
          <li class="special" @click="selectPost(0)"> <span>게시물 연결 없게 하기</span> </li>
          <template v-for="post in post_list" :key="post.idx">
            <li @click="selectPost(post.idx)" v-if="!searchText || post.title.includes(searchText)">
              <img
                :src="post.thumb && post.thumb.trim() !== '' ? post.thumb : '/imgs/empty_image.png'"
                alt="Thumbnail"
                class="thumb"
              />
              <h2>{{ post.title }}</h2>
            </li>
          </template>
        </ul>
      </div>
      
    </div>

  </div>
</template>

<script>
import { inject, ref } from 'vue';
import { useBackButton } from '@/utils/useBackBtn';

export default ({
  emits: ['submit'],
  props: { 
    onlyChose: {
      type: Boolean,
      default: false
    }
   },
  setup(props, { emit }) {
    const post_select = ref(0);
    const post_list = ref([]);
    const sql_query = inject('sql_query');
    const searchText = ref('');

    
    useBackButton(() => {
      quit();
    });

    async function fetchPosts() {
      const result = await sql_query(`SELECT * FROM board_reference WHERE is_temp != '1'`);
      post_list.value = result;
    }
    fetchPosts();

    function searchInput(e) {
      searchText.value = e.target.value;
    }

    function quit() {
      // Emit an event to close the dialog
      emit('submit', null);
    }

    function selectPost(idx) {
      let ask = confirm("선택이 확실합니까?");
      if (ask) {
        emit('submit', idx);
      }
    }

    return {
      quit,
      selectPost,
      post_select,
      post_list,
      searchText,
      searchInput
    };
  },
})
</script>


<style scoped>

#dialog-insu-company-picker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.paper {
  width: 90%;
  max-width: 600px;
  min-height: 10%;
  height:80%;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.chooser {
  width:100%;
  display:Flex;
  align-items: center;
  justify-content: center;
  gap:16px;
}

.chooser > input {
  width:100%;
  flex:1;
  height:40px;
  font-size:16px;
  padding:12px;
  box-sizing: border-box;
  border:none;
  border-radius: 100px;
}

.header {
  width:100%;
  display:Flex;
  align-items: center;
  justify-content: space-between;
  gap:16px;
}

.header > h2 {
  font-size:24px;
  padding:0;
  margin:0;
}

.header button {
  width:36px;
  height:36px;
  background: none;
  border:none;
  cursor:pointer;
  font-size:24px;
  display:flex;
  align-items: center;
  justify-content: center;
}

.content { 
  display: flex;
  align-items: start;
  justify-content: center;
  width:100%;
  max-height: 100%;
  flex:1;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.content::-webkit-scrollbar {
  display: none;
}

.content > ul {
  width:100%;
  display:flex;
  flex-direction: column;
  margin:0;
  padding:0;
  gap:16px;
  list-style: none;
}

.content > ul > li {
  width:100%;
  display:flex;
  gap: 12px;
  cursor:pointer;
}

.content > ul > li > img {
  width:200px;
  height:auto;
  aspect-ratio: 16/9;
  object-fit: cover;
  border-radius: 8px;
}

.content > ul > li > h2 {
  font-size:var(--font-size-lg);
  padding:0;
  margin:0;
}

.content > ul > li.special {
  background: var(--color-background-light);
  display:flex;
  align-items: center;
  justify-content: center;
  padding:16px;
  box-sizing: border-box;
  border-radius: 16px;
  cursor: pointer;
}
</style>